export const PRIMARY = '#FF4340';
export const INFO = '#3E3D40';
export const BLUE_PRIMARY = '#273E5A';
export const DISABLED_PRIMARY = '#FFC6C5';
export const BLACK_COLOR = '#1A171B';
export const LINK = '#29b6f6';
export const GRAY_BOX = "#F3F3F3";
export const GRAY = '#E2E6EA';